import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getMachinePhotos(companyId, machineId) {
	return dataTransferWrap(
		ModulesMap.MACHINE_PHOTOS,dtConfig[ModulesMap.MACHINE_PHOTOS].getMachinePhotos,
		{
			urlParams: {
				companyId: companyId,
				machineId,
			},
		}
	)
}

function createMachinePhoto(companyId, machineId, data) {
	return dataTransferWrap(
		ModulesMap.MACHINE_PHOTOS,dtConfig[ModulesMap.MACHINE_PHOTOS].createMachinePhoto,
		{
			urlParams: {
				companyId,
				machineId,
			},
			...data,
		},
	)
}

function getMachinePhoto(companyId, machineId, photosId) {
	return dataTransferWrap(
		ModulesMap.MACHINE_PHOTOS,dtConfig[ModulesMap.MACHINE_PHOTOS].getMachinePhoto,
		{
			urlParams: {
				companyId,
				machineId,
				photosId,
			},
		},
	)
}

function patchMachinePhoto(companyId, machineId, photosId, data) {
	return dataTransferWrap(
		ModulesMap.MACHINE_PHOTOS,dtConfig[ModulesMap.MACHINE_PHOTOS].patchMachinePhoto,
		{
			urlParams: {
				companyId,
				machineId,
				photosId,
			},
			...data,
		},
	)
}

function putMachinePhoto(companyId, machineId, photosId, data) {
	return dataTransferWrap(
		ModulesMap.MACHINE_PHOTOS,dtConfig[ModulesMap.MACHINE_PHOTOS].putMachinePhoto,
		{
			urlParams: {
				companyId,
				machineId,
				photosId,
			},
			...data,
		},
	)
}

function deleteMachinePhoto(companyId, machineId, photosId) {
	return dataTransferWrap(
		ModulesMap.MACHINE_PHOTOS,dtConfig[ModulesMap.MACHINE_PHOTOS].deleteMachinePhoto,
		{
			urlParams: {
				companyId,
				machineId,
				photosId,
			},
		},
	)
}

export default {
	getMachinePhotos,
	getMachinePhoto,
	patchMachinePhoto,
	putMachinePhoto,
	createMachinePhoto,
	deleteMachinePhoto,
}
